<template>

    <div id="agility_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="container">

            <div class="agility_scores_container">

                <AgilityScore :score="currentEval.saven_test.s3_agility_scores.ai" dimId="ai" :animDelay="50" />
                <AgilityScore :score="currentEval.saven_test.s3_agility_scores.as" dimId="as" :animDelay="150" />
                <!-- <AgilityScore :score="currentEval.saven_test.s3_agility_scores.ad" dimId="ad" :animDelay="200" /> -->
                <AgilityScore :score="currentEval.saven_test.s3_agility_scores.am" dimId="am" :animDelay="200" />
                <AgilityScore :score="currentEval.saven_test.s3_agility_scores.ac" dimId="ac" :animDelay="250" />
                <AgilityScore :score="currentEval.saven_test.s3_agility_scores.ag" dimId="ag" :animDelay="300" />

            </div>

        </div>
    </div>

</template>

<script>
import AgilityScore from '../scores/agilityScore'

export default {
    name: 'AgilityTab',
    components: {
        AgilityScore
    },
    beforeCreate() {

    },
    data(){
        return {
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.agility_scores_container{
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .agility_score_item:last-child{
        border-right: 1px solid $grey-lighter;
    }
}
</style>